import moment from 'moment';

export default {
	getLotInitialEnd() {
		return function(lot) {
			const { auction_end, additional_time } = lot;

			const end = moment.utc(auction_end).startOf('second');

			if (additional_time) {
				const additionalZero = moment.utc(additional_time).startOf('year');
				const additional = moment.utc(additional_time).startOf('second');
				const duration = moment.duration(additional.diff(additionalZero));
				end.subtract(duration);
			}

			return end;
		};
	},

	getLotProlongedEnd(state, getters) {
		return function(lot) {
			const currentEnd = moment.utc(lot.auction_end).startOf('second');
			const initialEnd = getters.getLotInitialEnd(lot);
			return currentEnd.isSame(initialEnd)
				? null
				: currentEnd;
		};
	},

	isLotOver() {
		return function(lot) {
			return ['FINISHED', 'CANCELED'].includes(lot.status);
		};
	},

	getLotDurationLeft() {
		return function(lot, clientServerTimeDelta = 0) {
			const end = moment.utc(lot.auction_end).startOf('second');
			const current = moment.utc().subtract(clientServerTimeDelta);
			const duration = moment.duration(current > end ? 0 : end - current);
			return duration;
		};
	},

	getLotPercentDone() {
		return function(lot) {
			const begin = moment.utc(lot.auction_begin).startOf('second');
			const current = moment.utc().startOf('second');
			const end = moment.utc(lot.auction_end).startOf('second');
			const full = moment.duration(begin > end ? 0 : end - begin);
			const fullMs = full.asMilliseconds();
			const done = moment.duration(begin > current ? 0 : current - begin);
			const doneMs = done.asMilliseconds();
			const percent = !fullMs
				? 100
				: Math.round(doneMs / fullMs * 100);
			return percent;
		};
	},

	isLotAtProlongation(state, getters) {
		return function(lot) {
			const prolongedEnd = getters.getLotProlongedEnd(lot);
			if (prolongedEnd) {
				const current = moment.utc().startOf('second');
				const initialEnd = getters.getLotInitialEnd(lot);
				return current.isBetween(initialEnd, prolongedEnd);
			}
			return false;
		};
	}
};
